export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker.90a0f757.mp4";